import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'
import { Breakpoints } from "@/shared/styles/breakpoints";

export const Container = styled.div`        
    flex-direction: column;

    display: flex;
    justify-content: space-between;       

    @media screen and (min-width: ${Breakpoints.menu}){
        flex-direction: row;
        margin-bottom: ${zero.ZrSpacingVerticalXxs}
    }
`
export const ArrowBox = styled.div`    
    width: 100%;
    display: flex;
    
    justify-content: center;
    
    @media screen and (min-width: ${Breakpoints.menu}){
        align-items: center;
        margin-top: ${zero.ZrSpacingVerticalMd};
        flex: 1;
        min-width: 70px;
    }    
`

export const TitleAndGroupedHardwareProfileBox = styled.div`
    flex: 1 auto;
    gap: ${zero.ZrSpacingVerticalXxs};    
`

export type TitleColors = 'blue' | 'gray'

type TitleProps = {
    color: TitleColors
}

export const Title = styled.p<TitleProps>`
    font-family: ${zero.ZrFontFamilyDigitalRegular};
    font-size: ${zero.ZrFontSizeNano};

    color: ${(props) => props.color == 'blue'? '#0088A5' : zero.ZrColorNeutralMedium02};
    
    span {
        font-weight: 600;        
    }
    
    @media screen and (min-width: ${Breakpoints.menu}){
        font-size: ${zero.ZrFontSizeXxs};
    }
`